import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ContentItem } from '../../../components/ContentItem';
import { selectAdvices, selectBlogs, selectQuestions } from '../../../slices';
import { EInfoTabs } from '../ContentTabsContainer';

const LIST_SIZE = 3;

export const useContentItems = (activeTab: string): React.ReactNode => {
  const blogs = useSelector(selectBlogs);
  const advices = useSelector(selectAdvices);
  const questions = useSelector(selectQuestions);

  return useMemo(() => {
    if (activeTab === EInfoTabs.Blogs) {
      return blogs.blogs.slice(0, LIST_SIZE).map(blog => {
        return (
          <ContentItem
            key={blog.id}
            title={blog.attributes.title}
            text={blog.attributes.subtitle}
            href={`/blogs-${blog.attributes.slug}-${blog.id}/`}
          />
        );
      });
    }

    if (activeTab === EInfoTabs.Advices) {
      return advices.advices.slice(0, LIST_SIZE).map(advice => {
        return (
          <ContentItem
            key={advice.id}
            title={advice.attributes.contentObject.title}
            text={advice.attributes.contentObject.subtitle}
            comment={advice.attributes.comment}
            href={`/forum-rieltorov-${advice.attributes.contentObject.slug}-${advice.id}/`}
          />
        );
      });
    }

    if (activeTab === EInfoTabs.Questions) {
      return questions.questions.slice(0, LIST_SIZE).map(question => {
        return (
          <ContentItem
            key={question.id}
            title={question.attributes.title}
            text={question.attributes.subtitle}
            href={`/forum-rieltorov-${question.attributes.slug}-${question.id}/`}
          />
        );
      });
    }

    return null;
  }, [activeTab, advices.advices, blogs.blogs, questions.questions]);
};
